import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useRootStore } from 'stores/RootStore'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import PlanSelect from '../screens/PlanSelect/PlanSelect'
import { AllPlans } from '../screens/AllPlans/AllPlans'
import { CheckoutScreen } from '../screens/Checkout/Checkout'
import { PaywallScreen } from 'stores/PaywallStore'
import { Spinner } from 'common/Spinner/Spinner'
import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './PaywallModal.module.scss'
import cx from 'classnames'
import { Success } from '../screens/Success/Success'
import { useSession } from 'hooks/useSession'

export const PaywallModal = observer(() => {
  const { paywallStore } = useRootStore()
  const workspace = useCurrentWorkspace()
  const { closeModal } = useModals()
  const { logout } = useSession()

  useEffect(() => {
    if (workspace) {
      paywallStore.ensureInitialized(workspace.id)
    }
  }, [workspace, paywallStore])

  const handleLogout = () => {
    paywallStore.reset()
    closeModal()
    logout()
  }

  if (paywallStore.isLoading) {
    return (
      <Modal.Root>
        <Modal.Content>
          <div className={Styles.loader}>
            <Spinner />
          </div>
        </Modal.Content>
      </Modal.Root>
    )
  }

  const renderScreen = () => {
    switch (paywallStore.currentScreen) {
      case PaywallScreen.PLAN_SELECT:
        return <PlanSelect onLogout={handleLogout} key="planSelect" />
      case PaywallScreen.ALL_PLANS:
        return <AllPlans key="allPlans" />
      case PaywallScreen.CHECKOUT:
        return <CheckoutScreen key="checkout" />
      case PaywallScreen.SUCCESS:
        return <Success />
      default:
        return <div> </div>
    }
  }

  return (
    <Modal.Root
      bodyClassName={cx(paywallStore.currentScreen === PaywallScreen.ALL_PLANS && Styles.largeModal)}
      onPressOutside={closeModal}
    >
      {renderScreen()}
    </Modal.Root>
  )
})
